import { socket, getSocketConnectionData } from '@speechki-frontend/core/socket';
import { getToken } from '@speechki-frontend/core/auth/utils';

import { uploadBook as apiUploadBook } from '../api/books';

const ERROR_MESSAGE = [
    {
        detail: 'Generation error, please try again'
    }
];
const TIMEOUT_LENGTH = 28000;

/**
 * Uploads book with response by websocket and fallback timeout
 * @param {*} book - book data
 * @param {*} isManage - when true apiUploadBook uses different endpoint
 * @param {*} callback - callback for websocket response data
 */
export const uploadBook = async (book, isManage, callback = () => {}) => {
    let promiseResolve, promiseReject, timeout;
    window.onbeforeunload = () => {
        clearTimeout(timeout);
    };

    const _book = await apiUploadBook(book, isManage);

    const ws = socket(getSocketConnectionData(getToken()));

    ws.receiver.on('create_book', handleCreateBookMessage);
    ws.receiver.on('record_process_book_part_update', handleBPUpdateMessage);

    async function handleCreateBookMessage({ code }) {
        ws.receiver.off('create_book', handleCreateBookMessage);
        if (code !== 200) {
            clearTimeout(timeout);
            return promiseReject(ERROR_MESSAGE);
        }
    }

    async function handleBPUpdateMessage({ code, params }) {
        if (code !== 200) {
            ws.receiver.off('record_process_book_part_update', handleBPUpdateMessage);
            return promiseReject(ERROR_MESSAGE);
        }

        await callback(params);

        if (params.action === 'reindex' && params.book_id === _book.id && params.is_completed) {
            ws.receiver.off('record_process_book_part_update', handleBPUpdateMessage);
            clearTimeout(timeout);
            timeout = null;

            return promiseResolve(_book);
        }
    }

    const promise = new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;

        timeout = setTimeout(() => {
            return resolve(_book);
        }, TIMEOUT_LENGTH);
    });

    return promise;
};
